import {Spinner} from '@kroll-resolver-crisp/ui-components-react';
import {useJobs} from '../api/hooks';
import {JobsTable} from '../components/jobs/JobsTable';
import {JobSubmitForm} from '../components/jobs/JobSubmitForm';
import {PageHeaderActions} from '@/components/layout/PageHeader';
import {TablePanel} from '@/components/ui/table-panel';

export function JobsPage() {
  const {data, isLoading} = useJobs({page: 1});
  const jobs = data?.results ?? [];

  return (
    <div className="space-y-4 p-4">
      <PageHeaderActions>
        <JobSubmitForm />
      </PageHeaderActions>
      {isLoading ? (
        <div
          className="text-muted-foreground flex items-center justify-center gap-2 p-6 text-xs"
          role="status">
          <Spinner /> Loading…
        </div>
      ) : (
        <TablePanel>
          <JobsTable jobs={jobs} />
        </TablePanel>
      )}
    </div>
  );
}
